"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _underscore = require("underscore");

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _FormattedJSXMessage = _interopRequireDefault(require("I18n/components/FormattedJSXMessage"));

var _UIBanner = _interopRequireDefault(require("UIComponents/alert/UIBanner"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _UILink = _interopRequireDefault(require("UIComponents/link/UILink"));

var _UIMediaObject = _interopRequireDefault(require("UIComponents/layout/UIMediaObject"));

var _UISection = _interopRequireDefault(require("UIComponents/section/UISection"));

var _UITrialActivationButton = _interopRequireDefault(require("ui-addon-upgrades/button/UITrialActivationButton"));

var _HubspotUrls = _interopRequireDefault(require("../../constants/HubspotUrls"));

var _utils = require("../../utils/utils");

var getI18nKey = (0, _underscore.memoize)(function (path) {
  return "MarketplaceUI.goodDetailsPage.ctaBanner." + path;
});

var getUrl = function getUrl(path) {
  return (0, _utils.getAppBaseUrl)() + "/" + path;
};

var TrialBanner = function TrialBanner(_ref) {
  var canTrialMarketing = _ref.canTrialMarketing,
      isCustomer = _ref.isCustomer,
      partial = _ref.partial,
      trackLinkClick = _ref.trackLinkClick,
      urlToken = _ref.urlToken;
  var redirectPath = encodeURIComponent(getUrl("l/marketplace/products/" + urlToken));
  var trialType = 'marketing-pro';
  var trialButton = isCustomer && canTrialMarketing ? _react.default.createElement(_UITrialActivationButton.default, {
    upgradeData: {
      app: 'marketplace',
      screen: 'goods-details',
      upgradeProduct: 'marketing-pro',
      uniqueId: 'banner'
    },
    use: "secondary",
    shouldHideSurvey: true,
    onSuccess: function onSuccess() {
      window.location.reload();
    }
  }) : _react.default.createElement(_UIButton.default, {
    className: "m-left-6",
    external: true,
    href: _HubspotUrls.default.FREE_TRIAL,
    onClick: partial(trackLinkClick, 'free-trial'),
    size: "extra-small"
  }, _react.default.createElement(_FormattedMessage.default, {
    message: getI18nKey('buttonText')
  }));
  return _react.default.createElement(_UISection.default, null, _react.default.createElement(_UIBanner.default, {
    titleText: _react.default.createElement(_FormattedMessage.default, {
      message: getI18nKey(trialType + ".title")
    })
  }, _react.default.createElement(_UIMediaObject.default, {
    align: "center",
    itemRight: trialButton
  }, isCustomer ? _react.default.createElement(_FormattedMessage.default, {
    message: getI18nKey(trialType + ".message")
  }) : _react.default.createElement(_FormattedJSXMessage.default, {
    message: getI18nKey(trialType + ".message_jsx"),
    options: {
      href: getUrl("login?loginRedirectUrl=" + redirectPath),
      use: 'on-dark',
      className: 'm-left-2'
    },
    elements: {
      Link: _UILink.default
    }
  }))));
};

TrialBanner.propTypes = {
  canTrialMarketing: _react.PropTypes.bool.isRequired,
  isCustomer: _react.PropTypes.bool.isRequired,
  partial: _react.PropTypes.func.isRequired,
  trackLinkClick: _react.PropTypes.func.isRequired,
  urlToken: _react.PropTypes.string.isRequired
};
var _default = TrialBanner;
exports.default = _default;
module.exports = exports.default;